// CreateBlogModal.js
import React, { useState, useRef } from "react";
import {
  Modal,
  Paper,
  TextField,
  Button,
  IconButton,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import "../../../../Assets/css/Community/MyfeedInfo.css";

const CreateBlogModal = ({ open, onClose }) => {
  const [blogTitle, setBlogTitle] = useState("");
  const [isPublic, setIsPublic] = useState(true);
  const [featuredImage, setFeaturedImage] = useState(null);
  const fileInputRef = useRef(null);
  const contentEditableRef = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFeaturedImage(URL.createObjectURL(file));
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleFormatCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    contentEditableRef.current.focus();
  };

  const handlePublish = () => {
    const content = contentEditableRef.current.innerHTML;
    const blogPost = {
      title: blogTitle,
      isPublic,
      featuredImage,
      content,
    };
    console.log("Publishing blog:", blogPost);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} className="modal-container">
      <Paper
        className="modal-paper"
        style={{
          backgroundColor: "white",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="modal-header">
          <h2 style={{ fontSize: "1.5rem", margin: 0 }}>Create Blog Post</h2>
          <IconButton onClick={onClose} style={{ marginLeft: "auto" }}>
            <CloseIcon />
          </IconButton>
        </div>

        <div
          className="modal-body"
          style={{ overflowY: "auto", padding: "0 16px", flex: 1 }}
        >
          <TextField
            fullWidth
            label="Blog Title"
            value={blogTitle}
            onChange={(e) => setBlogTitle(e.target.value)}
            variant="outlined"
            margin="normal"
            style={{ marginTop: "8px" }}
          />

          <div className="featured-image-section" style={{ margin: "12px 0" }}>
            {featuredImage ? (
              <div
                className="image-preview"
                onClick={triggerFileInput}
                style={{
                  borderRadius: "8px",
                  overflow: "hidden",
                  position: "relative",
                  height: "160px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f5f5f5",
                  cursor: "pointer",
                }}
              >
                <img
                  src={featuredImage}
                  alt="Featured preview"
                  style={{ maxHeight: "100%", maxWidth: "100%" }}
                />
                <div
                  className="image-overlay"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 68, 198, 0.7)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    color: "white",
                    opacity: 0,
                    transition: "opacity 0.3s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
                >
                  <ImageIcon style={{ color: "white", fontSize: "1.5rem" }} />
                  <span style={{ fontSize: "0.9rem", marginTop: "8px" }}>
                    Change Image
                  </span>
                </div>
              </div>
            ) : (
              <div
                onClick={triggerFileInput}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px dashed #ccc",
                  borderRadius: "8px",
                  padding: "20px",
                  cursor: "pointer",
                  height: "100px",
                  transition: "border-color 0.3s",
                }}
              >
                <ImageIcon
                  style={{
                    fontSize: "2rem",
                    color: "#0044c6",
                    marginBottom: "8px",
                  }}
                />
                <span style={{ color: "#0044c6", fontWeight: 500 }}>
                  Add Featured Image
                </span>
              </div>
            )}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageUpload}
              accept="image/*"
              style={{ display: "none" }}
            />
          </div>

          <div
            className="editor-container"
            style={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              marginTop: "12px",
            }}
          >
            <div
              className="toolbar"
              style={{
                padding: "6px",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#f5f5f5",
                display: "flex",
                gap: "6px",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              <button
                onClick={() => handleFormatCommand("bold")}
                style={{
                  background: "none",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  cursor: "pointer",
                  backgroundColor: "white",
                  fontSize: "0.875rem",
                }}
              >
                <b>B</b>
              </button>
              <button
                onClick={() => handleFormatCommand("italic")}
                style={{
                  background: "none",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  cursor: "pointer",
                  backgroundColor: "white",
                  fontSize: "0.875rem",
                }}
              >
                <em>I</em>
              </button>
              <button
                onClick={() => handleFormatCommand("underline")}
                style={{
                  background: "none",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  cursor: "pointer",
                  backgroundColor: "white",
                  fontSize: "0.875rem",
                }}
              >
                <u>U</u>
              </button>
              <button
                onClick={() => handleFormatCommand("formatBlock", "<h1>")}
                style={{
                  background: "none",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  cursor: "pointer",
                  backgroundColor: "white",
                  fontSize: "0.875rem",
                }}
              >
                H1
              </button>
              <button
                onClick={() => handleFormatCommand("formatBlock", "<h2>")}
                style={{
                  background: "none",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  cursor: "pointer",
                  backgroundColor: "white",
                  fontSize: "0.875rem",
                }}
              >
                H2
              </button>
              <button
                onClick={() => handleFormatCommand("formatBlock", "<h3>")}
                style={{
                  background: "none",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  cursor: "pointer",
                  backgroundColor: "white",
                  fontSize: "0.875rem",
                }}
              >
                H3
              </button>
            </div>
            <div
              ref={contentEditableRef}
              className="content-editable"
              contentEditable
              data-placeholder="Write your blog content here..."
              style={{
                minHeight: "150px",
                padding: "12px",
                outline: "none",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            ></div>
          </div>
        </div>

        <div
          className="modal-footer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            borderTop: "1px solid #eee",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={isPublic}
                onChange={(e) => setIsPublic(e.target.checked)}
                color="primary"
              />
            }
            label={isPublic ? "Public" : "Private"}
            style={{ marginLeft: "0" }}
          />
          <div>
            <Button
              onClick={onClose}
              style={{ marginRight: "8px", color: "#666" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handlePublish}
              style={{
                backgroundColor: "#0044c6",
                color: "white",
                padding: "6px 16px",
                textTransform: "none",
                fontWeight: 500,
              }}
            >
              Publish Blog
            </Button>
          </div>
        </div>
      </Paper>
    </Modal>
  );
};

export default CreateBlogModal;
